import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { toast } from 'react-toastify';
import * as api from './api';
import type { ImageFolder } from './api';

function describeError(err: unknown, fallback: string): string {
  if (isAxiosError(err)) {
    const data = err.response?.data as
      | { message?: string | string[]; error?: string }
      | undefined;
    const msg = data?.message;
    if (Array.isArray(msg)) return msg.join(', ');
    if (typeof msg === 'string' && msg.length > 0) return msg;
    if (data?.error) return data.error;
  }
  return fallback;
}

export function useUploadImage(folder: ImageFolder) {
  return useMutation({
    mutationFn: (file: File) => api.uploadImage(file, folder),
    onError: (err) => toast.error(describeError(err, 'Image upload failed')),
  });
}
